export default "__VITE_ASSET__jHQxsokv__"